import { createSelector } from 'reselect';
import type { RootState } from 'store';
import { getShowReportPanel } from 'store/settings/selectors';
import { Panel } from './reducer';

export const getShowReportButton = (state: RootState) =>
  state.layout.openPanel === null;

export const getShowProjectData = (state: RootState) =>
  state.layout.openPanel === Panel.PROJECT_DATA;

export const getShowFlowProperties = (state: RootState) =>
  state.layout.openPanel === Panel.FLOW_PROPERTIES;

export const getShowSettings = (state: RootState) =>
  state.layout.openPanel === Panel.SETTINGS;

export const getShowPerformanceGuarantee = (state: RootState) =>
  state.layout.openPanel === Panel.PERFORMANCE_GUARANTEE;

export const getShowRiskAssessment = (state: RootState) =>
  state.layout.openPanel === Panel.RISK_ASSESSMENT;

export const getShowEquipmentSelection = (state: RootState) =>
  state.layout.openPanel === Panel.EQUIPMENT_SELECTION;

export const getShowSideCard = (state: RootState) => state.layout.showSideCard;

export const getHasPrimaryRightSidePanel = (state: RootState) =>
  state.unitConnGroup.present.unitState.activeUnit !== null ||
  getShowProjectData(state) ||
  getShowSettings(state) ||
  getShowPerformanceGuarantee(state) ||
  getShowRiskAssessment(state) ||
  getShowEquipmentSelection(state);

export const getRightSidePanelCount = createSelector(
  [
    getHasPrimaryRightSidePanel,
    getShowSideCard,
    getShowReportPanel,
    getShowEquipmentSelection,
  ],
  (
    hasPrimaryRightSidePanel,
    showSideCard,
    showReportPanel,
    showEquipmentSelection,
  ) =>
    Number(hasPrimaryRightSidePanel) +
    Number(showSideCard) +
    Number(showReportPanel) +
    Number(showEquipmentSelection),
);

export const getRunningChamberAnalysisSimulations = (state: RootState) =>
  state.layout.runningChamberAnalysisSimulations;

export const getFailedChamberAnalysisSimulations = (state: RootState) =>
  state.layout.failedChamberAnalysisSimulations;

export const getShowApproveFileModal = (state: RootState) =>
  state.layout.showApproveFileModal;

export const getSkipsDiagramUpdate = (state: RootState) =>
  state.layout.skipsDiagramUpdate;

export const getRiskAssessmentSelectedUnits = (state: RootState) =>
  state.layout.riskAssessmentSelectedUnits;
